module.exports = __webpack_public_path__ + "img/google-play.995ce5cd.svg";